/** Apples to Apples' config. Every field needs a `.default()`: an unhosted preset has nobody to ask. */
import { z } from 'zod';
/** Strict, so a saved format carrying `{handsize: 5}` fails at the boundary. */
export const applesConfigSchema = z.strictObject({
    /**
     * `firstToN` reads the count off `ctx.scores`; `unlimited` ends only when the leader ends it.
     * The auto-form has no conditional fields, so whichever of `rounds`/`winTarget` is ignored still renders.
     */
    winCondition: z.enum(['rounds', 'firstToN', 'unlimited']).default('rounds'),
    /** Used only when `winCondition` is `firstToN`. */
    winTarget: z.number().int().min(1).max(20).default(5),
    /** Used only when `winCondition` is `rounds`. */
    rounds: z.number().int().min(1).max(30).default(8),
    handSize: z.number().int().min(2).max(12).default(7),
    /** Floor is two: one candidate would ask the judge to choose from a list of one. */
    promptOptions: z.number().int().min(2).max(4).default(2),
    /** Deadlock guard: without it one unanswered phone stalls the play request forever. */
    playSeconds: z.number().int().min(15).max(300).default(90),
});
/** For tests calling `reduce` directly; the server parses `{}` through the schema. */
export const APPLES_DEFAULT_CONFIG = applesConfigSchema.parse({});
/** Takes a partial config: `GET /api/games` calls it with `{}`. */
export function applesEstimatedMinutes(config) {
    const condition = config.winCondition ?? APPLES_DEFAULT_CONFIG.winCondition;
    // ~2.5 min a round plus one to settle in. `firstToN` uses N as the floor (one player wins
    // every round); `unlimited` gets a nominal figure.
    const rounds = condition === 'firstToN'
        ? (config.winTarget ?? APPLES_DEFAULT_CONFIG.winTarget)
        : condition === 'unlimited'
            ? 10
            : (config.rounds ?? APPLES_DEFAULT_CONFIG.rounds);
    return Math.max(1, Math.round(1 + rounds * 2.5));
}
//# sourceMappingURL=config.js.map